import { toast } from 'react-toastify';
import { TOAST_CONFIG } from '../const';

export const handleSuccessToast = (message) => {
  if (message) {
    toast.dismiss();
    toast.success(message, TOAST_CONFIG);
  }
};

